import CodeEmbed from './CodeEmbed';

class HistoricalCodeEmbed extends CodeEmbed {
  protected readonly disablePreviewing = true;
}

export default HistoricalCodeEmbed;
